//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { guessLike } from '@/api/index'
import Swiper from "swiper/swiper-bundle.min.js";
import { Toast, Overlay, Loading  } from 'vant';
export default {
  components: {
    [Toast.name]: Toast,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading
  },
  data () {
    return {
      goodList: [{},{}],
      currentIndex: 1,
      showHandle: false, //操作提示
      showLoading: true,//页面加载loading
    };
  },
  beforeRouteLeave(to, from, next) {

     sa.track("recommendation_click", {
        operat_type: 0,
        view_page: this.currentIndex
      });
    next()
    console.log(to)
  },



  computed: {},

  created(){
    this.firstTimeFun()
    this.getGuessList()
  },

  mounted(){
     this.swiperInit()
  },

  methods: {
    //获取商品
    getGuessList() {
      guessLike().then(res => {
        this.goodList = res.data
        this.showLoading = false
        this.$nextTick(() => {
          this.swiperInit()
        })
      })
    },
    firstTimeFun() {
      let isFirstTime = localStorage.getItem('isFirstTime')
      if(isFirstTime==1){

      }else{
        this.showHandle = true
      }
      console.log(isFirstTime,'isFirstTime')
    },
    //去商品详情
    goProduct(item) {
       sa.track("recommendation_click", {
        operat_type: 1,
        view_page: this.currentIndex
      });
      let goodsCode=""
      if(item.goodsCode.indexOf('?') != -1){
        goodsCode = item.goodsCode.split('?')[0]
      }else{
        goodsCode = item.goodsCode
      }
      window.location.href = process.env.PAGEURL + "/goodDetails?gid=" + goodsCode + "&utm_source=sytuijian";
       // window.location.href =process.env.PRODUCTURL + "/detail/" + goodsCode + "?utm_source=sytuijian"
    },
    //关闭弹窗
    closeHandle() {
      localStorage.setItem('isFirstTime',1)
      this.showHandle = false
    },
     //swiper
    swiperInit() {
      let _this= this
      var swiper = new Swiper(".swiper", {
        pagination: {
          el: ".swiper-pagination",
          // clickable: true,
           type: 'progressbar',
        },
        // loop: true,
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        // },
        observer: true,
        lazyLoading: true,
        on: {
            transitionEnd: function(event){
                var index = this.realIndex; //用  realIndex可选择对应高亮轮播
                _this.currentIndex = index + 1
                console.log(index)
                if(_this.currentIndex == _this.goodList.length){
                  Toast('已经是最后一个了');
                }
            },
            slidePrevTransitionEnd:function(){
              console.log('pre');
            },
            slideNextTransitionEnd:function(){
             console.log('next');
            },
        },
      });
      // return swiper;
    },
  }
}




// WEBPACK FOOTER //
// ./src/view/guessLike/guessLike.vue